import MessageBroker from "./message-broker.js";
import Messages from "./messages.js";

// Current breakpoint string (cache to avoid DOM activity)
let currentBreakpoint = {
  key: "pre-load",
  value: null,
};

const bodyNode = document.body;
const MAJOR_BREAKPOINT = 768;

function current() {
  return currentBreakpoint;
}

function determineBreakpoint() {
  const lastBreakpoint = currentBreakpoint;
  const computedStyle = getComputedStyle(bodyNode, ":before");
  const rawBreakpoint = computedStyle
      .getPropertyValue("content")
      .replace(/['"]+/g, "");
  const [key, value] = rawBreakpoint.split(":");
  currentBreakpoint = {
    key,
    value,
  };
  if (
      lastBreakpoint.key !== currentBreakpoint.key &&
      lastBreakpoint.value !== currentBreakpoint.value
  ) {
    const lastWidth = parseInt(lastBreakpoint.value, 10),
        currentWidth = parseInt(currentBreakpoint.value, 10),
        majorBreakpointChanged =
            (lastWidth < MAJOR_BREAKPOINT && currentWidth >= MAJOR_BREAKPOINT) ||
            (lastWidth >= MAJOR_BREAKPOINT && currentWidth < MAJOR_BREAKPOINT);
    MessageBroker.publish(Messages.BREAKPOINT.CHANGED, {
      breakpoint: currentBreakpoint,
      majorBreakpointChanged,
    });
  }
}

/**
 * Checks if current breakpoint key is in given breakpoints key list
 * @param {string[]} breakpoints list of keys
 */
function keyIsIn(breakpoints) {
  const key = current().key;
  return breakpoints.indexOf(key) !== -1;
}

MessageBroker.subscribe(Messages.WINDOW.RESIZED, determineBreakpoint);

/* Determine breakpoint initially */
determineBreakpoint();

export default {
  current,
  keyIsIn,
};
